module.exports = __webpack_public_path__ + "static/media/1.78c7579.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/1.wav
// module id = Nrk5
// module chunks = 0